import {
  EditorColorScheme,
  PortalBgType,
  PortalBorderType,
  PortalShadowType,
  PortalTextType,
  PortalThemeColors,
  TailwindCommonPalette,
  TailwindExtraPalette,
} from '@nx-frontend/shared/types';

export const ThemeCarbon: PortalThemeColors = {
  key: 'carbon',
  iconSet: 'default',
  name: 'Carbon',
  thumbnail: '/assets/img/themes/carbon/carbon.png',
  preview: '/assets/img/themes/carbon/carbon-preview-full.png',
  description: 'Sleek dark design with subtle metallic highlights',
  hidden: false,
  comingSoon: false,
  icon: '/assets/img/icon-light.svg',
  editorColor: EditorColorScheme.LIGHT,
  logo: {
    main: { url: '/assets/img/themes/sky-blue/sky-blue-logo.svg' },
    footer: { url: '/assets/img/themes/sky-blue/sky-blue-logo.svg' },
  },
  imagesHead: {
    enabled: true,
    base: {
      url: '/assets/img/themes/sky-blue/sky-blue-bg.png',
    },
  },
  variants: [
    {
      rules: {
        notPath: '/',
      },
      modify: {
        imagesHead: undefined,
        [PortalBgType.HEADER]: [TailwindCommonPalette.NEUTRAL_900],
      },
    },
  ],
  [PortalBgType.PRIMARY]: [TailwindCommonPalette.NEUTRAL_900],
  [PortalBgType.SECONDARY]: [TailwindCommonPalette.SKY_200],
  [PortalBgType.HEADER]: [TailwindCommonPalette.TRANSPARENT],
  [PortalBgType.HEADER_MENU]: [TailwindCommonPalette.TRANSPARENT],
  [PortalBgType.BODY]: [TailwindCommonPalette.GRAY_50],
  [PortalBgType.FOOTER]: [TailwindCommonPalette.NEUTRAL_900],
  [PortalBgType.SURFACE]: [TailwindCommonPalette.WHITE],
  [PortalBgType.SURFACE_DISABLE]: [TailwindCommonPalette.NEUTRAL_50],
  [PortalBorderType.SURFACE_DISABLE]: [TailwindCommonPalette.NEUTRAL_400],
  [PortalTextType.SURFACE_DISABLE]: [TailwindCommonPalette.NEUTRAL_400],
  [PortalBgType.SURFACE_TEXT]: [TailwindCommonPalette.BLACK],
  [PortalBgType.SURFACE_VARIANT]: [TailwindCommonPalette.WHITE],
  [PortalBgType.SURFACE_INNER]: [TailwindCommonPalette.WHITE],
  [PortalBgType.SURFACE_INNER_VARIANT]: [TailwindCommonPalette.WHITE],
  [PortalBgType.SURFACE_INNER_VARIANT_2]: [TailwindCommonPalette.WHITE],
  [PortalBorderType.SURFACE]: [TailwindCommonPalette.GRAY_100],
  [PortalBorderType.SURFACE_VARIANT]: [TailwindCommonPalette.GRAY_100],
  [PortalBorderType.SURFACE_INNER]: [TailwindCommonPalette.NEUTRAL_200],
  [PortalBorderType.SURFACE_INNER_VARIANT]: [TailwindCommonPalette.NEUTRAL_100],
  [PortalBorderType.FOOTER]: [TailwindCommonPalette.NEUTRAL_900],
  [PortalShadowType.MAIN]: [TailwindCommonPalette.TRANSPARENT],
  [PortalShadowType.HOVER]: [TailwindCommonPalette.TRANSPARENT],
  [PortalShadowType.SEARCH]: [TailwindExtraPalette.GRAY_200_50],
  [PortalBgType.HEADER_HOVER]: [TailwindCommonPalette.NEUTRAL_700],
  [PortalBgType.BODY_HOVER]: [TailwindCommonPalette.SKY_100],
  [PortalBgType.SURFACE_VARIANT_HOVER]: [TailwindCommonPalette.WHITE],
  [PortalBgType.SURFACE_INNER_HOVER]: [TailwindCommonPalette.SKY_50],
  [PortalBgType.SURFACE_INNER_HOVER_2]: [TailwindCommonPalette.SKY_100],
  [PortalBgType.PRIMARY_HOVER]: [TailwindCommonPalette.NEUTRAL_800],
  [PortalBgType.SURFACE_INNER_VARIANT_HOVER_2]: [TailwindCommonPalette.SKY_50],
  [PortalBgType.SECONDARY_HOVER]: [TailwindCommonPalette.SKY_300],
  [PortalBorderType.SURFACE_HOVER]: [TailwindCommonPalette.GRAY_200],
  [PortalBorderType.SURFACE_VARIANT_HOVER]: [TailwindCommonPalette.GRAY_200],
  [PortalBorderType.SURFACE_INNER_HOVER]: [TailwindCommonPalette.NEUTRAL_200],
  [PortalTextType.FOOTER_HOVER]: [TailwindCommonPalette.SKY_300],
  [PortalTextType.HERO_TEXT]: [TailwindCommonPalette.WHITE],
  [PortalBgType.GREETING_1]: [TailwindCommonPalette.WHITE],
  [PortalBgType.GREETING_2]: [TailwindCommonPalette.WHITE],
  [PortalTextType.SURFACE]: [TailwindCommonPalette.NEUTRAL_900],
  [PortalTextType.SURFACE_2]: [TailwindCommonPalette.NEUTRAL_800],
  [PortalTextType.SURFACE_3]: [TailwindCommonPalette.NEUTRAL_500],
  [PortalTextType.SURFACE_VARIANT]: [TailwindCommonPalette.NEUTRAL_900],
  [PortalTextType.SURFACE_VARIANT_2]: [TailwindCommonPalette.NEUTRAL_500],
  [PortalTextType.SURFACE_INNER]: [TailwindCommonPalette.NEUTRAL_800],
  [PortalTextType.SURFACE_INNER_2]: [TailwindCommonPalette.NEUTRAL_500],
  [PortalTextType.SURFACE_INNER_VARIANT]: [TailwindCommonPalette.NEUTRAL_800],
  [PortalTextType.SURFACE_INNER_VARIANT_2]: [TailwindCommonPalette.NEUTRAL_500],
  [PortalTextType.SECONDARY]: [TailwindCommonPalette.NEUTRAL_800],
  [PortalTextType.HEADER]: [TailwindCommonPalette.WHITE],
  [PortalTextType.HEADER_HOVER]: [TailwindCommonPalette.WHITE],
  [PortalTextType.BODY]: [TailwindCommonPalette.SLATE_500],
  [PortalTextType.BODY_VARIANT]: [TailwindCommonPalette.NEUTRAL_900],
  [PortalTextType.FOOTER]: [TailwindCommonPalette.WHITE],
  [PortalTextType.FOOTER_2]: [TailwindCommonPalette.NEUTRAL_300],
  [PortalBgType.FOOTER_DIVIDER]: [TailwindCommonPalette.NEUTRAL_500],
  [PortalTextType.TOOLTIP]: [TailwindCommonPalette.BLACK],
  [PortalBgType.TOOLTIP]: [TailwindCommonPalette.WHITE],
  [PortalTextType.PRIMARY]: [TailwindCommonPalette.NEUTRAL_900],
  [PortalTextType.ON_PRIMARY]: [TailwindCommonPalette.WHITE],
  [PortalTextType.PRIMARY_HOVER]: [TailwindCommonPalette.NEUTRAL_800],
  [PortalBorderType.PRIMARY]: [TailwindCommonPalette.NEUTRAL_900],
  [PortalBorderType.PRIMARY_HOVER]: [TailwindCommonPalette.NEUTRAL_800],
  [PortalBgType.HEADER_LINKS]: [TailwindCommonPalette.TRANSPARENT],
  [PortalBgType.FOOTER_LINE]: [TailwindCommonPalette.TRANSPARENT],
  [PortalBgType.FOOTER_LINKS]: [TailwindCommonPalette.TEAL_600],
  [PortalBgType.FILL_SURFACE]: [TailwindCommonPalette.GRAY_500],
  [PortalBgType.FILL_SURFACE_2]: [TailwindCommonPalette.NEUTRAL_900],
  [PortalBgType.FOOTER_LINKS_HOVER]: [TailwindCommonPalette.SKY_300],
  [PortalBgType.EDIT_BG]: [TailwindCommonPalette.NEUTRAL_800],
  [PortalTextType.EDIT_TEXT]: [TailwindCommonPalette.BLACK],
  [PortalBorderType.EDIT_BORDER]: [TailwindCommonPalette.BLACK],
  [PortalBgType.WARN_SURFACE]: [TailwindCommonPalette.AMBER_50],
};
